const LessThanCircleIcon = /*#__PURE__*/ [
  ["path", { d: "M14 8L10.6678 11.0203C9.77741 11.8273 9.77741 12.1727 10.6678 12.9797L14 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { LessThanCircleIcon as default };
//# sourceMappingURL=LessThanCircleIcon.js.map
